import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import commonStyles from '../../../styles';
import MemberStatusCode from '../../../eleCommon/memberStatusCode';
import LastReceivedAt from './lastReceivedAt';
import { getEnvVariable } from '../../../../commonFunction/getEnv';

const useStyles = makeStyles({
  itemWrap: {
    display: 'flex',
    borderBottom: '1px #F3F3F3 solid',
    alignItems: 'center',
    padding: '8px 16px',
    width: '100%',
    boxSizing: 'border-box',
  },
  leftButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    // 比率の指定
    flex: '3 1 0%',
    minWidth: 0,
    width: '100%',
    padding: '4px 12px',
    textTransform: 'none',
    borderRadius: 0,
    color: 'inherit',
  },
  rightButton: {
    flex: '7 1 0%',
    minWidth: 0,
    textTransform: 'none',
    padding: '4px 0 4px 16px',
    textAlign: 'left',
    display: 'block',
    borderRadius: 0,
  },
  lastReceivedAtWrapper: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-start',
  },
  lineLink: {
    fontSize: '11px',
    fontWeight: 'bold',
    textDecoration: 'underline',
    whiteSpace: 'nowrap',
    textAlign: 'right',
    flexShrink: 0,
  },
  grid: {
    flexWrap: 'nowrap',
    overflow: 'hidden',
  },
  customerName: {
    width: 'auto',
    marginRight: 8,
    marginBottom: 2,
    textOverflow: 'ellipsis',
  },
  txtWrap: {
    width: '100%',
  },
  subTxt: {
    textAlign: 'left',
  },
  shrink: {
    flexShrink: 0,
  },
});

function ListItemComponent(props) {
  const { data, setOpen, setCutstomerId } = props;
  const common = commonStyles();
  const classes = useStyles();
  const { customer } = data;

  /**
   * クリックされたらLINEリンクを開く処理
   */
  const handleLinkClick = () => {
    const lineUrl = getEnvVariable('LINE_URL') + customer.hashCustomerId;
    window.open(lineUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={classes.itemWrap}>
      <Button
        className={classes.leftButton}
        onClick={handleLinkClick}
      >
        <div className={classes.lastReceivedAtWrapper}>
          <LastReceivedAt lastReceivedAt={data.lastReceivedAt} />
        </div>
        <Typography className={classes.lineLink} color="primary">
          LINEリンク
        </Typography>
      </Button>
      <Button
        className={classes.rightButton}
        onClick={() => {
          setOpen(true);
          setCutstomerId(customer.id);
        }}
      >
        <Grid className={classes.txtWrap}>
          <Grid container alignItems="center" className={classes.grid}>
            <Typography className={`${common.title4} ${classes.customerName}`}>
              {customer.fullName}
            </Typography>
            <Typography className={`${common.title4} ${classes.customerName}`}>
              {customer.status}
            </Typography>
            <Typography className={`${common.title6} ${classes.shrink}`}>
              <MemberStatusCode
                hideNonMemberIcon
                code={customer.memberStatusCode}
              />
            </Typography>
          </Grid>
          <Typography className={classes.subTxt} style={{ lineHeight: 1 }}>
            <span className={common.title5}>反響日 </span>
            <span className={common.small}>{customer.effectAt}</span>
          </Typography>
          <Typography className={classes.subTxt} style={{ lineHeight: 1 }}>
            <span className={common.title5}>担当 </span>
            <span className={common.verySmall}>
              {data.user}
            </span>
          </Typography>
        </Grid>
      </Button>
    </div>
  );
}

export default ListItemComponent;
